module.exports = __webpack_public_path__ + "img/mbh-info-shape.8dae9f91.svg";